import LandingNavbar from "../../components/landing/LandingNavbar";
import HeroSection from "../../components/landing/HeroSection";
import HowItWorksSection from "../../components/landing/HowItWorksSection";
import LiveDashboardSection from "../../components/landing/LiveDashboardSection";
import FeaturesSection from "../../components/landing/FeaturesSection";
import WhyBestSection from "../../components/landing/WhyBestSection";
import PricingSection from "../../components/landing/PricingSection";
import FinalCTASection from "../../components/landing/FinalCTASection";
import "./style.scss";

export default function LandingPage() {
  return (
    <div className="landing-page">
      <LandingNavbar />
      <HeroSection />
      <FeaturesSection />
      <HowItWorksSection />
      <LiveDashboardSection />
      <WhyBestSection />
      <PricingSection />
      <FinalCTASection />
    </div>
  );
}
